<div id="graphstatusdiv" #graphstatusdiv class="graph-status" [style.height.px]="height">
</div>